<template>
  <div>
    <div class="top">
      <div class="card notice">
        <div class="name">
          <div class="icon">
            <fps-icon type="annoucement" />
          </div>{{$t('upgrade_page_views_dashboard_index_1431')}}</div>
        <el-carousel
          height="48px"
          direction="vertical"
          indicator-position="none"
          :autoplay="true"
          :loop="true"
        >
          <el-carousel-item v-for="(notices, index) in noticeList" :key="index">
            <ul>
              <li v-for="item in notices" :key="item.showOrder">
                <button class="dialog-btn" @click="clickNotice(item)">
                  <span class="title">{{ item.title }}</span>
                  <span class="date">{{showDate(item.onlineTime)}}</span>
                </button>
              </li>
            </ul>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="card service-wrap">
      <div class="title" style="margin-bottom:12px">{{$t('upgrade_page_views_dashboard_index_1432')}}</div>
      <el-select
        class="reason-picker-val input-tip"
        v-model="timeOpt"
        style="width:132px"
        @change="getData"
      >
        <el-option
          v-for="item in timeOptions"
          :key="item.value"
          :label="item.text"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        class="reason-picker-val input-tip"
        v-model="skillOpt"
        style="width:132px"
        @change="getData"
      >
        <el-option
          v-for="item in skillOptions"
          :key="item.value"
          :label="item.text"
          :value="item.value"
        ></el-option>
      </el-select>
      <div class="service">
        <div v-for="(item, i) in dataService" :key="'service-' + i" class="service-item">
          <div class="title">
            {{ item.title }}
            <el-tooltip
              class="item"
              popper-class="dashbord-tooltip"
              effect="dark"
              :content="item.explain"
              placement="top-end"
              :offset="-10"
            >
              <fps-icon type="question" class="icon" />
            </el-tooltip>
          </div>
          <div v-if="item.percent === null" class="data">
            <span>--</span>
          </div>
          <div v-else class="data">
            <span>{{ item.value!=undefined ? item.value : item.percent + '%' }}</span>
            <div class="progress" :class="rankColor[getTxtIdx(item)]">
              <div class="progress-bar" :style="{ width: `${item.percent}%` }"></div>
              <div
                v-if="!loading"
                class="progress-line"
                :style="{ left: `${item.percent < item.line[0] ? item.line[0] : item.line[1]}%` }"
              ></div>
            </div>
            <fps-icon v-if="!loading && item.percent < item.line[0]" type="failure" class="icon" />
          </div>
          <div v-if="item.percent === null" class="text">
            <p>{{ item.nullText }}</p>
          </div>
          <div v-else-if="!loading" class="text">
            <!-- eslint-disable-next-line vue/no-parsing-error -->
            <p>{{ item.text[getTxtIdx(item)] }}</p>
          </div>
        </div>
      </div>
      <el-collapse>
        <el-collapse-item :title="$t('upgrade_page_views_dashboard_index_1433')" name="1">
          <div class="box-wrap">
            <div class="box" v-for="(item,index) in detailData" :key="index">
              <div class="txt-1">{{item[0].title}}</div>
              <div class="txt-2">{{item[0].value || 0}}</div>
              <!-- <div class="txt-3">{{item[0].inc!=undefined?(item[0].inc>=0?'+':'')+item[0].inc:''}}</div> -->
              <div class="txt-1" v-if="item[1]">{{item[1].title}}</div>
              <div class="txt-2" v-if="item[1]">{{item[1].value || 0}}</div>
              <!-- <div
                class="txt-3"
                v-if="item[1]"
              >{{item[1].inc!=undefined?(item[1].inc>=0?'+':'')+item[1].inc :''}}</div>-->
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="card data-wrap">
      <div class="title">{{$t('upgrade_page_views_dashboard_index_1434')}}<span>{{$t('upgrade_page_views_dashboard_index_1435', [ dataOverview.time ])}}</span>
        <div class="data-flex">
          <div v-for="(item, i) in dataOverview.list" :key="'over-' + i" class="data-item">
            <div class="title">
              {{ item.title }}
              <el-tooltip
                class="item"
                popper-class="dashbord-tooltip"
                effect="dark"
                :content="item.explain"
                placement="top"
              >
                <fps-icon type="question" class="icon" />
              </el-tooltip>
            </div>
            <div class="data">{{ item.value }}</div>
            <div v-if="item.diff > 0" class="change success">
              <div>{{ item.diff }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card score-wrap">
      <div class="title">{{$t('upgrade_page_views_master_index_210')}}
        <!-- <span>近30日</span> --></div>
      <div class="dashboard-wrap">
        <scoreDash ref="scoreDash" class="dashboard" :score="playerScore" />
        <div class="explain">
          <div>{{$t('upgrade_page_views_dashboard_index_1436')}}</div>
          <p>{{$t('upgrade_page_views_dashboard_index_1437')}}</p>
          <div>{{$t('upgrade_page_views_dashboard_index_1438')}}</div>
          <p>{{$t('upgrade_page_views_dashboard_index_1439')}}</p>
        </div>
      </div>
    </div>
    <el-dialog
      :visible="showNoticeDialog"
      class="notice-dialog"
      custom-class="dialog-clear-style notice-dialog-wrap"
      append-to-body
      width="375px"
      :show-close="false"
      top="0"
    >
      <div class="notice-container">
        <div class="notice-header">
          <span>{{$t('upgrade_page_views_dashboard_index_1440')}}</span>
          <fps-icon
            class="close-dialog"
            type="close"
            size="24"
            @click.native="showNoticeDialog = false"
          />
        </div>
        <div class="scroll-wrap">
          <div class="notice-title">{{ activeNotice.title }}</div>
          <div v-html="activeNotice.content" class="notice-content" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex'
import scoreDash from '@/components/ScoreExplain/dashboard'
import { getServeList } from '../../../api/app';

export default {
  components: {
    scoreDash
  },
  data() {
    return {
      rankColor: ['warning', 'avg', 'good', ''],
      timeOpt: true,
      skillOpt: 'all',
      timeOptions: [{
        value: true,
        text: i18n.t('upgrade_page_views_dashboard_index_1441'),
      }, {
        value: false,
        text: i18n.t('upgrade_page_views_dashboard_index_1442'),
      }],
      skillOptions: [{
        value: 'all',
        text: i18n.t('upgrade_page_layout_nav_50'),
      }],
      loading: true,
      noticeList: [],
      bannerList: [],
      noticeContent: '',
      activeNotice: {},
      showNoticeDialog: false,
      dataOverview: {
        time: '',
        list: [{
          title: i18n.t('upgrade_page_views_dashboard_index_1443'),
          explain: i18n.t('upgrade_page_views_dashboard_index_1444'),
          value: '0.00',
          diff: 0,
        }, {
          title: i18n.t('upgrade_page_views_dashboard_index_1445'),
          explain: i18n.t('upgrade_page_views_dashboard_index_1446'),
          value: '0.00',
          diff: 0,
        }, {
          title: i18n.t('upgrade_page_views_dashboard_index_1447'),
          explain: i18n.t('upgrade_page_views_dashboard_index_1448'),
          value: 0,
          diff: 0,
        }]
      },
      dataService: [{
        title: i18n.t('upgrade_page_views_dashboard_index_1449'),
        explain: i18n.t('upgrade_page_views_dashboard_index_1450'),
        percent: 0,
        line: [40, 43, 50],
        text: [i18n.t('upgrade_page_views_dashboard_index_1451'), i18n.t('upgrade_page_views_dashboard_index_1452'), i18n.t('upgrade_page_views_dashboard_index_1453'), i18n.t('upgrade_page_views_dashboard_index_1454')],
        nullText: i18n.t('upgrade_page_views_dashboard_index_1455'),
      }, {
        title: i18n.t('upgrade_page_views_dashboard_index_1456'),
        explain: i18n.t('upgrade_page_views_dashboard_index_1457'),
        value: 0,
        percent: 0,
        line: [25, 50, 75],
        text: [i18n.t('upgrade_page_views_dashboard_index_1458'), i18n.t('upgrade_page_views_dashboard_index_1459'), i18n.t('upgrade_page_views_dashboard_index_1460'), i18n.t('upgrade_page_views_dashboard_index_1454')],
        nullText: i18n.t('upgrade_page_views_dashboard_index_1461'),
      },
      {
        title: i18n.t('upgrade_page_views_dashboard_index_1462'),
        explain: i18n.t('upgrade_page_views_dashboard_index_1463'),
        percent: 0,
        line: [70, 85],
        text: [i18n.t('upgrade_page_views_dashboard_index_1464'), i18n.t('upgrade_page_views_dashboard_index_1465'), i18n.t('upgrade_page_views_dashboard_index_1466')],
        nullText: i18n.t('upgrade_page_views_dashboard_index_1467'),
      }, 
      {
        title: i18n.t('upgrade_page_views_dashboard_index_1468'),
        explain: i18n.t('upgrade_page_views_dashboard_index_1469'),
        percent: 0,
        line: [60, 80],
        text: [i18n.t('upgrade_page_views_dashboard_index_1470'), i18n.t('upgrade_page_views_dashboard_index_1471'), i18n.t('upgrade_page_views_dashboard_index_1472')],
        nullText: i18n.t('upgrade_page_views_dashboard_index_1473'),
      }],
      playerScore: 0,
      detailData: []
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  async created() {
    await this.getData()
    await getServeList().then(rs => {
      this.skillOptions = this.skillOptions.concat((rs.data.Success || []).map(v => ({
        value: v.gameId,
        text: v.gameName
      })))
    })
    this.loading = false
  },
  mounted() {
  },
  methods: {
    getTxtIdx(item) {
      let idx = item.line.findIndex(v => v > item.percent);
      if (idx == -1) {
        idx = item.line.length;
      }
      if (item.line.length == 2 && idx > 0) {
        return idx + 1;
      }
      return idx;
    },
    showDate(onlineTime = 0) {
      const date = new Date(onlineTime)
      let m = date.getMonth() + 1
      if (m < 10) m = '0' + m
      let d = date.getDate()
      if (d < 10) d = '0' + d
      return `${m}-${d}`
    },
    getK(number) {
      if (number >= 1e5) {
        return Number((number / 1e3).toFixed(0)) + 'K'
      }
      else if (number >= 1e4) {
        return Number((number / 1e3).toFixed(1)) + 'K'
      }
      return Number(number.toFixed(0));
    },
    async getData() {
      await this.$http.get('/user/dashboard/data', {
        day60: this.timeOpt,
        gameId: Number(this.skillOpt) || undefined
      })
        .then(({
          data: {
            createTime,// 截止时间 ,
            goodComment,// 有效好评数 ,
            goodCommentAll,// 总好评数 ,
            goodCommentRate,// 有效好评率 ,
            lastDayAmount,// 昨日收入 ,
            monthAmount,// 本月收入 ,
            orderNewUser,// 二次下单新用户数 ,
            orderNewUserDiff,
            // orderRate,// 成单率 ,
            // orderSecondAmount,// 二次下单总金额 ,
            // orderSecondAmountDiff,
            orderSecondUser,// 二次下单人数 ,
            orderSecondUserDiff,
            playerScore,// 质量分 ,
            replyRate,// 1分钟回复率 ,
            repurchasePerAmount,// 人均回單金额 ,
            // repurchasePerContent,// 人均复购等级内容 ,
            // repurchasePerLevel,// 人均复购等级 ,
            repurchaseRate,// 复购率,
            repurchaseAmount,
            totalAmount,
          } }) => {
          const date = new Date(createTime - 24 * 60 * 60 * 1000)
          this.dataOverview = [
            {
              value: this.$util.moneySplit(lastDayAmount),
            },
            {
              title: (date.getDate() === 1 ? date.getMonth() : date.getMonth() + 1) + i18n.t('upgrade_page_views_dashboard_index_1445'),
              value: this.$util.moneySplit(monthAmount),
            },
            {
              value: totalAmount || 0,
              diff: orderNewUserDiff,
            },
          ].reduce((rs, item, index) => {
            for (var attr in item) {
              rs.list[index][attr] = item[attr]
            }
            return rs
          }, this.dataOverview)
          this.$set(this.dataOverview, 'time', `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`)
          this.playerScore = playerScore || 0
          this.$nextTick(() => {
            this.$refs.scoreDash.animate();
          })
          this.dataService = [repurchaseRate, this.getK(repurchasePerAmount), replyRate, goodCommentRate].map((item, i) => {
            const obj = this.dataService[i]
            if (i == 1) {
              obj.value = item;
              if (item < 800) {
                obj.percent = 10;
              } else if (item < 1000) {
                obj.percent = 30
              } else if (item < 1400) {
                obj.percent = 60
              } else {
                obj.percent = 90
              }
              return obj
            }
            obj.percent = Number((item * 100).toFixed(1))
            return obj
          })
          this.detailData = [[{
            title: i18n.t('upgrade_page_views_dashboard_index_1474'),
            value: orderNewUser,
            inc: orderNewUserDiff,
          }, {
            title: i18n.t('upgrade_page_views_dashboard_index_1475'),
            value: orderSecondUser,
            inc: orderSecondUserDiff,
          }],
          [{
            title: i18n.t('upgrade_page_views_dashboard_index_1476'),
            value: repurchaseAmount,
            inc: 0,
          }],
          // [{
          //   title: '1分鐘回覆次數',
          //   value: 'nodata',
          //   inc: 'nodata',
          // }, {
          //   title: '發起消息人數',
          //   value: 'nodata',
          //   inc: 'nodata',
          // }],
          [{
            title: i18n.t('upgrade_page_views_dashboard_index_1477'),
            value: goodComment,
          }, {
            title: i18n.t('upgrade_page_views_dashboard_index_1478'),
            value: goodCommentAll,
          }],
          ]
        })
      await this.$http.get('/user/dashboard/banner')
        .then(({ data: {
          bannerList, // banner图片list
          reportList, // 公告list
        } }) => {
          this.bannerList = bannerList
          const noticeList = []
          while (reportList.length > 1) {
            noticeList.push(reportList.splice(0, 1))
          }
          noticeList.push(reportList)
          this.noticeList = noticeList
        })
    },
    clickNotice(item) {
      if (item.jumpUrl) {
        if (/^http/.test(item.jumpUrl)) {
          location.href = item.jumpUrl
          return
        }
        this.$router.push({
          path: item.jumpUrl,
        })
      } else {
        this.activeNotice = {
          ...item,
          content: item.content.replace(/\n/g, '<br>'),
        }
        this.showNoticeDialog = true
      }
    },
    swipeChange(method) {
      let $swipe = this.$refs.banner
      if (!$swipe) return
      if (!$swipe[method]) return
      $swipe[method]()
    },
  }
}
</script>

<style lang="scss">
.banner-dashboard {
  .el-carousel__indicators {
    bottom: 8px;
  }
}
.dashbord-tooltip {
  max-width: 148px;
  font-size: 12px;
  line-height: 18px;
}
</style>

<style lang="scss" scoped>
.dialog-btn {
  width: 100%;
  @include flex(flex-start);
  justify-content: space-between;
  .title {
    color: $color-gray-1;
    font-size: 14px;
    line-height: 20px;
    max-width: 363px;
    @include ellipsis;
    &:hover {
      color: $color-link;
    }
  }
  .time {
    color: rgba($color: $color-gray-2, $alpha: 0.5);
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
  }
}
.notice-dialog {
  & /deep/ &-wrap {
    background: #fff;
    border-radius: 4px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.notice-container {
  display: flex;
  flex-direction: column;
  max-height: 60vh;
  overflow: hidden;
  .notice-header {
    @include flex(space-between);
    height: 49px;
    border-bottom: 1px solid $color-button;
    padding: 0 16px 0 24px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $color-gray-1;
    .close-dialog {
      cursor: pointer;
      color: rgba(34, 44, 67, 0.2);
    }
  }
  .scroll-wrap {
    flex: 1;
    overflow-y: auto;
    @include hideScrollBar(0, 0);
    padding: 20px 24px 32px;
    text-align: left;
    .notice-title {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: $color-gray-1;
    }
    .notice-content {
      margin-top: 12px;
      font-size: 14px;
      line-height: 22px;
      color: $color-gray-2;
    }
  }
}
.card {
  background: #fff;
  border: 1px solid $color-split;
  border-radius: 4px;
  margin-top: 12px;
  padding: 16px 24px;
  > .title {
    color: $color-gray-1;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    span {
      color: $color-gray-3;
      font-size: 14px;
      font-weight: normal;
      margin-left: 24px;
      vertical-align: top;
    }
  }
}
.top {
  @include flex(center, stretch);
  padding-top: 12px;
  > * {
    flex-grow: 1;
    width: 100%;
    overflow: hidden;
  }
  .notice {
    margin-right: 6px;
    padding: 12px 24px;
    @include flex;
    align-items: flex-start;
    .el-carousel {
      flex: 1;
      padding-left: 24px;
      overflow-y: hidden;
      max-height: 24px;
    }
    .name {
      @include flex(flex-start);
      color: #5362ec;
      font-size: 14px;
      font-weight: 500;
      // padding-bottom: 8px;
      .icon {
        @include flex;
        width: 24px;
        height: 24px;
        border-radius: 100%;
        background-color: #5362ec;
        color: #fff;
        margin-right: 4px;
      }
    }
    ul {
      padding-bottom: 8px;
      li {
        margin-bottom: 8px;
        font-size: 14px;
        line-height: 20px;
        margin-top: 2px;
        @include ellipsis;
        a {
          color: $color-gray-1;
          &:hover {
            color: $color-link;
          }
        }
      }
    }
  }
  .banner {
    position: relative;
    overflow: hidden;
    margin-top: 12px;
    margin-left: 6px;
    height: 156px;
    border-radius: 4px;
    .banner-item {
      display: block;
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: auto;
      }
    }
    .custom-arrow-left,
    .custom-arrow-right {
      width: 28px;
      height: 28px;
    }
    .custom-arrow-left {
      left: 8px;
    }
    .custom-arrow-right {
      right: 8px;
    }
  }
}
.data-wrap {
  .data-flex {
    display: flex;
    justify-content: space-between;
    padding: 40px 0 16px;
    .data-item {
      text-align: left;
      .title {
        @include flex(flex-start);
        color: $color-gray-1;
        font-size: 14px;
        font-weight: normal;
        line-height: 20px;
        .icon {
          color: $color-gray-3;
          font-size: 18px;
          margin-left: 2px;
        }
      }
      .data {
        margin-top: 8px;
        color: $color-gray-1;
        font-size: 24px;
        font-weight: bold;
        line-height: 34px;
      }
      .change {
        @include flex(flex-start);
        height: 16px;
        &.success {
          color: $color-green;
          font-size: 12px;
          font-weight: bold;
          line-height: 16px;
          &::before {
            content: '+';
            margin-right: 2px;
          }
        }
        &.warning {
          font-size: 12px;
          font-weight: bold;
          line-height: 16px;
          color: $color-red;
          &::before {
            content: '';
            @include triangle(6px, $color-red);
          }
        }
      }
      .item /deep/ .item-tooltip {
        max-width: 40px;
      }
    }
  }
}
.service-wrap {
  padding-right: 46px;
  .service {
    @include flex(space-between);
    padding: 40px 0 16px;
    .service-item {
      width: 200px;
      height: 125px;
      .title {
        @include flex(flex-start);
        color: $color-gray-1;
        font-size: 14px;
        line-height: 20px;
        .icon {
          color: $color-gray-3;
          font-size: 18px;
          margin-left: 2px;
        }
      }
      .data {
        @include flex(flex-start);
        position: relative;
        margin-top: 8px;
        > span {
          flex-shrink: 0;
          color: $color-gray-1;
          font-size: 24px;
          font-weight: 500;
        }
        .progress {
          flex-grow: 1;
          position: relative;
          width: 100%;
          height: 12px;
          background-color: $color-split;
          margin-left: 12px;
          &-bar {
            position: absolute;
            z-index: 1;
            left: 0;
            top: 0;
            height: 100%;
            background-color: $color-link;
            transition: width 0.45s;
          }
          &-line {
            position: absolute;
            z-index: 2;
            bottom: 0;
            width: 1px;
            height: 15px;
            background-color: #c4c4c4;
            &::before {
              content: '';
              position: absolute;
              left: -2px;
              top: 0;
              @include triangle(3px, #c4c4c4);
            }
            &::after {
              content: '優異';
              position: absolute;
              left: 50%;
              transform: translate(-50%, -15px);
              color: $color-price;
              font-size: 10px;
              line-height: 14px;
              white-space: nowrap;
            }
          }
          &.good {
            .progress-bar {
              background-color: #3BBC2A;
            }
            .progress-line::after {
              content: '良好';
              color: #3BBC2A;
            }
          }                
          &.avg {
            .progress-bar {
              background-color: #3BBC2A;
            }
            .progress-line::after {
              content: '有待提升';
              color: #3bbc2a;
            }
          }          
          &.warning {
            .progress-bar {
              background-color: $color-red;
            }
            .progress-line::after {
              content: '低於標準';
              color: $color-red;
            }
          }
        }
        .icon {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translate(24px, -50%);
          color: $color-orange;
          font-size: 16px;
        }
      }
      .text {
        margin-top: 16px;
        color: $color-gray-3;
        font-size: 12px;
        line-height: 18px;
      }
    }
  }
}
.score-wrap {
  margin-bottom: 40px;
  .dashboard-wrap {
    @include flex;
    overflow: hidden;
    .dashboard {
      flex-shrink: 0;
      width: 300px;
      height: 230px;
      margin-left: -20px;
    }
    .explain {
      flex-grow: 1;
      @include flex(center, stretch, column);
      margin-left: 50px;
      div {
        color: rgba(34, 44, 67, 0.8);
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
      }
      p {
        color: $color-gray-3;
        font-size: 14px;
        line-height: 22px;
        margin-top: 4px;
        + div {
          margin-top: 24px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.el-collapse {
  border: none;
  .box-wrap {
    padding-top: 20px;
    @include flex(space-around);
  }
  .box {
    width: 213px;
    // height: 252px;
    height: 210px;
    background: #ffffff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 40px 0;
    @include flex(flex-start, center, column);
    .txt-1 {
      font-size: 14px;
    }
    .txt-2 {
      font-size: 24px;
      font-weight: 700;
    }
    .txt-3 {
      font-size: 12px;
      color: #3bbc2a;
      font-weight: 500;
    }
  }
}
.card .el-collapse-item__header {
  width: 116px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  border: 1px solid #e8eaee;
  border-radius: 50px;
  height: 36px;
  color: #636d86;
  .el-collapse-item__arrow {
    margin: 0;
  }
}
</style>
